import { useUserStore } from '@/store/userStore'

function readLoggedUserFromLocalStorage() {
  try {
    const raw = window.localStorage.getItem('loggedUser')
    if (!raw) return { name: '' }
    return JSON.parse(raw)
  } catch {
    return { name: '' }
  }
}

function createPermissionsBridge() {
  const havePagePermission = (page) => useUserStore().userHasPagePermission(page)

  const haveParentPermission = (parent) => {
    if (!parent) return true
    if (!window.localStorage.getItem('loggedUser')) return false

    const userStore = useUserStore()
    const permissions = userStore.pagePermissions

    if (userStore.isMercafacilAdmin || permissions?.includes('mf/admin')) {
      return true
    }

    return permissions?.some((permission) => permission.split('/')[0] === parent)
  }

  return {
    havePagePermission,
    haveParentPermission,
  }
}

export default {
  install(app) {
    const permissions = createPermissionsBridge()

    app.config.globalProperties.$getLoggedUser = readLoggedUserFromLocalStorage
    app.config.globalProperties.$getSecurity = () => useUserStore().security ?? {}
    app.config.globalProperties.$getAllowedModules = () => useUserStore().allowedModules ?? {}
    app.config.globalProperties.$getIsEcommerce = () => useUserStore().isEcommerce
    app.config.globalProperties.$isLogged = () => window.localStorage.getItem('loggedUser') !== null
    app.config.globalProperties.$permissions = permissions
    app.config.globalProperties.$hasPiiAccess = () => Boolean(useUserStore().hasPiiAccess)

    app.mixin({
      computed: {
        hasPiiAccess() {
          return this.$hasPiiAccess()
        },
      },
      methods: {
        getSafe(fn) {
          try {
            return fn()
          } catch {
            return undefined
          }
        },
      },
    })
  },
}
